import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from '@helpers/helper';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { ExpedienteFilter } from '@models/expediente/expedienteFilter.model';
import { DeletePersonaRequest } from '@models/persona/deletePersonaRequest.model';
import { PersonaDetailDto } from '@models/persona/personaDetailDto.model';
import { ContactoService } from '@services/contacto/contacto.service';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { PericiaService } from '@services/pericia/pericia.service';
import { PersonaService } from '@services/persona/persona.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ContactoDto } from '@models/contacto/contactoDto.model';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { CardViewContactosSimpleComponent } from '@views/contactos/card-view-contactos-simple/card-view-contactos-simple.component';
import { ListContactoComponent } from '@views/contactos/list-contacto/list-contacto.component';
import { ListExpedienteComponent } from '@views/expedientes/list-expediente/list-expediente.component';
import { MatCardModule } from '@angular/material/card';
import { GoBackAndTitleComponent } from '@component/go-back-and-title/go-back-and-title.component';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { A11yModule } from '@angular/cdk/a11y';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';

@Component({
  standalone: true,
  imports: [AppRolesDirective, StatusBadgeComponent, CardViewContactosSimpleComponent, ListContactoComponent, ListExpedienteComponent, MatCardModule, GoBackAndTitleComponent, MatButtonModule, MatCardModule, CommonModule, MatTabsModule, NgxSpinnerModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, A11yModule, CommonModule, MatExpansionModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, MatCheckboxModule, MatAutocompleteModule, MatChipsModule],
  selector: 'app-form-persona-view',
  templateUrl: './form-persona-view.component.html',
  styleUrls: ['./form-persona-view.component.css']
})
export class FormPersonaViewComponent {
  personaDetailDto!: PersonaDetailDto;
  idPersona: any;
  dataSourceExpediente = new MatTableDataSource<ExpedienteDto>();
  dataExpediente: boolean = false
  displayedColumnsExpediente!: string[];
  contactos!: ContactoDto[];
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private personaService: PersonaService,
    private snackBar: SnackBarService,
    private periciasService: PericiaService,
    private breakpointObserver: BreakpointObserver,
    private contactoService: ContactoService,
    private expedienteService: ExpedienteService

  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumnsExpediente = result.matches ?
        ["caratula", "accion"] :
        ["caratula", "identificadorUnico", "estadoExpediente", "accion"];
    });

  }


  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  ngOnInit(): void {
    this.idPersona = this.activatedRoute.snapshot.params['id']
    this.getPersonaById(this.idPersona)
    this.getAllExpedienteByIdPersona(this.idPersona)
  }
  getPersonaById(id: number) {
    this.spinner.show("spPersona")
    this.personaService.getPersonaById(id)
      .subscribe(
        data => {
          this.spinner.hide("spPersona")
          this.personaDetailDto = data
          this.personaService.setPersona(data)
          this.getAllContactosByIdPersona(data.id)
        },
        error => {
          this.spinner.hide("spPersona")
          this.snackBar.showError(error, "Error");
        })
  }

  openDialogDelete(obj: any) {
    obj.id = obj.id
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "50%",
      dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogDeleteComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      this.deleteRowData(result.data);
    });
  }

  deleteRowData(id: number) {
    this.spinner.show('spPersona')
    this.personaService.delete(id)
      .subscribe(
        data => {
          this.spinner.hide('spPersona')
          this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
          this.router.navigate(["/personas"])
        },
        error => {
          this.spinner.hide('spPersona')
          this.snackBar.showError(error, "Error");
        });
  }

  copiarAlPortapapeles(texto: string) {
    Helper.copyToClipboard(texto)
  }

  onContactosActualizados(lista: ContactoDto[]) {
    this.contactos = [...lista]
  }

  getAllExpedienteByIdPersona(idPersona: number) {
    this.spinner.show('spExpediente')
    let expedienteFilter = new ExpedienteFilter
    expedienteFilter.idsPersona?.push(idPersona);
    this.expedienteService.getAllExpedientesByFilter(expedienteFilter)
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.dataSourceExpediente.data = data.sort((a, b) => a.caratula.toString().localeCompare(b.caratula.toString())) as ExpedienteDto[]
          this.dataExpediente = this.dataSourceExpediente.data.length >= 1 ? true : false

        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllContactosByIdPersona(idPersona: number) {
    this.spinner.show('spContactos')
    this.contactoService.getAllByIdPersona(idPersona)
      .subscribe(
        data => {
          this.spinner.hide('spContactos')
          this.contactos = data

        },
        error => {
          this.spinner.hide('spContactos')
          this.snackBar.showError(error, "Error");
        })
  }
}
